<script>
  import { Autocomplete } from 'element-ui'
  export default {
    name:'ElAutocomplete',
    extends:Autocomplete
}
</script>
